import { messageHandlerRegistry } from '@reducers/v2/messagesBus/handlerRegistry';
import { ProductionInformationMessageType } from '@reducers/v2/messagesBus/types';
import { TTL_FOR_IMAGE } from '@v2/components/imageHandling/constants';

messageHandlerRegistry.configure(ProductionInformationMessageType.ADDED_PRODUCTION_INFORMATION, { ttl: TTL_FOR_IMAGE });
